export default __webpack_public_path__ + "static/media/type.06774706.mp3";